import React from 'react';
import './App.css';
import { Link } from "react-router-dom";

export default function Nav() {
    const navStyle = {
        color: '#61dafb',
        textDecoration: 'none'
        };
    const listStyle = {
        listStyleType: 'none',
        // display: 'inline',
        listStylePosition: 'outside',
        margin: 0,
        padding: 0
        // borderWidth: 2,
        // borderStyle: 'solid',
        // borderColor: 'yellow'
    }

    return (
        <nav>
            <div className="Nav-name">
            <Link style={navStyle} to="/" >
                <h3>TASHI NAMGYAL</h3>
            </Link>
            </div>
            <div className="Nav-links">
            <ul style={listStyle}>
                <Link style={navStyle} to="/midi-draw">
                    <li>🎹 MIDI-Draw ✍</li>
                </Link>
                <Link style={navStyle} to="/complexetron">
                    <li>🥁 Complexetron 🥁</li>
                </Link>
            </ul>
            </div>
        </nav>
    );
}
